import {keyBy, lowerCase, bounce, sortBy} from 'helpers';
import {store} from 'store';

export function update({all, grabbed, name, container, modelId}) {
  const nodes = keyBy(container.querySelectorAll('[draggable]'), 'dataset.id');
  const ids = sortBy(all, (id) => {
    if (grabbed.id == id) {
      return grabbed.clientY;
    } else if (nodes[id]) {
      return nodes[id].getBoundingClientRect().y;
    }
    return 999999999999;
  }).join(',');

  if (ids !== all.join(',')) {
    store.dispatch({
      type: 'SORTING_UPDATE',
      ids,
      modelId,
      name: name,
      objectType: grabbed.type
    });
    store.dispatch({
      type: 'UI_SETTING',
      module: lowerCase(name),
      key: name === 'Goals' ? 'sort' : 'group',
      value: 'customOrder'
    });
    bounce(grabbed.target);
  }
}
